export default {
    methods:{
        openNotification(position = null, color, icon=null, title, text, duration) {
          let colorNotification, iconNotification;
          if (color === "success-sh") {
            iconNotification = '<i class="fas fa-check-circle text-sucess-variant-sh" style="font-size:1.5rem"></i>'
            colorNotification = this.$status_1_variant;
          }
          if (color === "warning-sh") {
            iconNotification = '<i class="fa-solid fa-triangle-exclamation text-warning-sh" style="font-size:1.5rem"></i>'
            colorNotification = this.$status_2;
          }
          if (color === "danger-sh"){ 
            iconNotification = '<i class="fa-solid fa-circle-exclamation text-danger-sh" style="font-size:1.5rem"></i>'
            colorNotification = this.$status_3;
          }
          if (color === "info-sh"){ 
            iconNotification = '<i class="fa-solid fa-circle-info text-secondary-variant" style="font-size:1.5rem"></i>'
            colorNotification = this.$secondary_variant;
          }
            const noti = this.$vs.notification({
              icon: iconNotification,
              // color: colorNotification,
              border: colorNotification,
              position,
              title,
              text,
              duration
            })
          }
    }
  };